import './assets/styles/nprogress.css'
import { trackPromise } from 'react-promise-tracker'
import { useLoadingIndicator } from './hooks/useLoadingIndicator'

export { trackPromise, useLoadingIndicator }
